import clsx from 'clsx';
import React from 'react';

import s from './shared.module.less';

export const Attention: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...rest }) => (
  <div {...rest} className={clsx(s.attention, className)}>
    {children}
  </div>
);
